import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import clsx from 'clsx'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../../messages'
import { configContext } from '../DnaPlates'
import {
  scaleValues,
  shippingValues,
  Specifications,
  plate,
  PlateProduct,
} from '../enum'
import Grid from '@material-ui/core/Grid'
import { checkValidKey } from '@src/routes/Configurators/utils/util'

const useStyles = makeStyles((theme: Theme) => {
  return {
    contentWrapper: {
      backgroundColor: 'white',
      padding: theme.spacing(2, 5, 2, 5),
    },
    mgBottom3: {
      marginBottom: theme.spacing(3),
    },
    mgBottom: {
      marginBottom: theme.spacing(2),
    },
    mgTop: {
      marginTop: theme.spacing(14),
    },
    mgTop1: {
      marginTop: theme.spacing(2),
    },
    font12: {
      fontSize: theme.typography.pxToRem(12),
    },
    font18: {
      fontSize: theme.typography.pxToRem(18),
    },
    subHead: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: theme.typography.fontWeightBold,
      margin: theme.spacing(3, 0),
    },
    subTotal: {
      marginBottom: theme.spacing(5),
      display: 'flex',
      fontSize: theme.typography.pxToRem(16),
    },
    mgLeft12: {
      marginLeft: theme.spacing(15),
    },
    mgLeft13: {
      marginLeft: theme.spacing(2),
    },
  }
})
export interface OrderSummaryProps {
  productDetails: any
}
const OrderSummary: React.FC<OrderSummaryProps> = (props) => {
  const { productDetails } = props
  const classes = useStyles()
  const intl = useIntl()
  const { state } = React.useContext(configContext)
  const { sessionData } = state
  return (
    <>
      <Grid className={classes.contentWrapper}>
        <Grid className={clsx(classes.mgBottom3, classes.font12)}>
          <h2 className={classes.subHead}>
            <FormattedMessage {...messages.CONF_DNAPLATES_ORDER_SUMMARY} />
          </h2>
          <Divider />
        </Grid>
        <Grid className={clsx(classes.font18, classes.mgBottom3)}>
          <FormattedMessage
            {...messages.CONF_DNAPLATES_ORDER_SUMMARY_PLATE_SPECIFICATIONS}
          />
        </Grid>
        {productDetails.productType === PlateProduct.DuplexPlate ? (
          <>
            <Grid container className={classes.mgBottom}>
              <Grid item sm={6}>
                <strong>
                  <FormattedMessage {...messages.CONF_AMOUNT} />
                </strong>
              </Grid>
              <Grid item sm={5}>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].amount !== '' &&
                sessionData[0].amount !== null &&
                sessionData[0].amount !== undefined
                  ? sessionData[0].amount
                  : ''}
                <FormattedMessage {...messages.CONF_DUPLEX_AMOUNT_MOLES} />
              </Grid>
            </Grid>
            <Grid container className={classes.mgBottom}>
              <Grid item sm={6}>
                <strong>
                  <FormattedMessage
                    {...messages.CONF_PURIFICATION_DNA_PLATES}
                  />
                </strong>
              </Grid>
              <Grid item sm={6}>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].purification !== '' &&
                sessionData[0].purification !== null &&
                sessionData[0].purification !== undefined
                  ? intl.formatMessage(
                      checkValidKey(
                        messages[sessionData[0].purification],
                        sessionData[0].purification
                      )
                    )
                  : ''}
              </Grid>
            </Grid>
          </>
        ) : (
          ''
        )}
        <Grid container className={classes.mgBottom}>
          <Grid item sm={6}>
            <strong>
              <FormattedMessage {...messages.CONF_FORMAT_DNA_PLATES} />
            </strong>
          </Grid>
          <Grid item sm={6}>
            {sessionData[0].plateName !== plate.NewPlate &&
            sessionData[0].format !== '' &&
            sessionData[0].format !== null &&
            sessionData[0].format !== undefined
              ? sessionData[0].format === Specifications.Other
                ? intl.formatMessage(messages.CONF_DNAPLATE_OTHER)
                : intl.formatMessage(
                    checkValidKey(
                      messages[sessionData[0].format],
                      sessionData[0].format
                    )
                  )
              : ''}
          </Grid>
        </Grid>
        {productDetails.productType !== PlateProduct.DuplexPlate ? (
          <>
            <Grid container className={classes.mgBottom}>
              <Grid item sm={6}>
                <strong>
                  <FormattedMessage
                    {...messages.CONF_PURIFICATION_DNA_PLATES}
                  />
                </strong>
              </Grid>
              <Grid item sm={6}>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].purification !== '' &&
                sessionData[0].purification !== null &&
                sessionData[0].purification !== undefined
                  ? intl.formatMessage(
                      checkValidKey(
                        messages[sessionData[0].purification],
                        sessionData[0].purification
                      )
                    )
                  : ''}
              </Grid>
            </Grid>

            {sessionData[0].format !== Specifications.DRY ? (
              <div>
                <Grid container className={classes.mgBottom}>
                  <Grid item sm={6}>
                    <strong>
                      <FormattedMessage
                        {...messages.CONF_CONCENTRATION_DNA_PLATES}
                      />
                    </strong>
                  </Grid>
                  <Grid item sm={6}>
                    {sessionData[0].plateName !== plate.NewPlate &&
                    sessionData[0].concentration !== '' &&
                    sessionData[0].concentration !== null &&
                    sessionData[0].concentration !== undefined
                      ? sessionData[0].concentration
                      : ''}{' '}
                    <FormattedMessage
                      {...messages.CONF_DNAPLATES_CONCENTRATION_MEASURE}
                    />
                  </Grid>
                </Grid>
                {sessionData[0].category === Specifications.Yes ? (
                  <Grid container className={classes.mgBottom}>
                    <Grid item sm={6}>
                      <strong>
                        <FormattedMessage
                          {...messages.CONF_VOLUME_DNA_PLATES}
                        />
                      </strong>
                    </Grid>
                    <Grid item sm={6}>
                      {sessionData[0].plateName !== plate.NewPlate &&
                      sessionData[0].amount !== '' &&
                      sessionData[0].amount !== null &&
                      sessionData[0].amount !== undefined
                        ? sessionData[0].amount
                        : ''}
                      <FormattedMessage
                        {...messages.CONF_DNAPLATES_VOLUME_MEASURE}
                      />
                    </Grid>
                  </Grid>
                ) : (
                  ''
                )}
              </div>
            ) : sessionData[0].category === Specifications.Yes ? (
              <Grid container className={classes.mgBottom}>
                <Grid item sm={6}>
                  <strong>
                    <FormattedMessage {...messages.CONF_AMOUNT} />
                  </strong>
                </Grid>
                <Grid item sm={5}>
                  {sessionData[0].plateName !== plate.NewPlate &&
                  sessionData[0].amount !== '' &&
                  sessionData[0].amount !== null &&
                  sessionData[0].amount !== undefined
                    ? sessionData[0].amount
                    : ''}
                  <FormattedMessage {...messages.CONF_DNAPLATES_AMOUNT_MOLES} />
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <Grid container className={classes.mgBottom}>
              <Grid item sm={6}>
                <strong>
                  <FormattedMessage {...messages.CONF_SCALE_DNA_PLATES} />
                </strong>
              </Grid>
              <Grid item sm={6}>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].scale !== '' &&
                sessionData[0].scale !== null &&
                sessionData[0].scale !== undefined ? (
                  sessionData[0].scale === scaleValues.UMO25 ? (
                    <FormattedMessage {...messages._PC_SPEC_0_025UM} />
                  ) : sessionData[0].scale === scaleValues.UMO50 ? (
                    <FormattedMessage {...messages._PC_SPEC_0_05UM} />
                  ) : sessionData[0].scale === scaleValues.UMO2 ? (
                    <FormattedMessage {...messages._PC_SPEC_0_2UM} />
                  ) : sessionData[0].scale === scaleValues.UMO1 ? (
                    <FormattedMessage {...messages._PC_SPEC_1_0UM} />
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
            <Grid container className={classes.mgBottom}>
              <Grid item sm={6}>
                <strong>
                  <FormattedMessage
                    {...messages.CONF_DNAPLATES_ORDER_SUMMARY_DAUGHTER_PLATES}
                  />
                </strong>
              </Grid>
              <Grid item sm={6}>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].daughterPlateCount !== '' &&
                sessionData[0].daughterPlateCount !== null &&
                sessionData[0].daughterPlateCount !== undefined
                  ? sessionData[0].daughterPlateCount
                  : ''}
              </Grid>
            </Grid>
          </>
        ) : (
          ''
        )}

        <div className={classes.mgTop}>
          <div>
            <span className={classes.font18}>
              <FormattedMessage
                {...messages.CONF_DNAPLATES_ORDER_SUMMARY_PACKAGING_OPTIONS}
              />
            </span>
            <div className={clsx(classes.mgTop1, classes.font12)}></div>
            {productDetails.productType !== PlateProduct.DuplexPlate ? (
              <span>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].packageType !== undefined
                  ? sessionData[0].packageType !== null &&
                    sessionData[0].packageType !== ''
                    ? sessionData[0].isPackageTypeOther
                      ? sessionData[0].packageType
                      : intl.formatMessage(
                          checkValidKey(
                            messages[sessionData[0].packageType],
                            sessionData[0].packageType
                          )
                        )
                    : ''
                  : ''}
              </span>
            ) : (
              <span>
                {' '}
                <FormattedMessage {...messages.PLATE_96_DEEP_800} />
              </span>
            )}
            <div className={clsx(classes.mgBottom, classes.font12)}></div>
            {productDetails.productType !== PlateProduct.DuplexPlate ? (
              <span>
                {sessionData[0].plateName !== plate.NewPlate &&
                sessionData[0].shipping !== '' &&
                sessionData[0].shipping !== null &&
                sessionData[0].shipping !== undefined ? (
                  sessionData[0].shipping === shippingValues.Ambient ? (
                    <>
                      <FormattedMessage
                        {...messages.CONF_DUPLEX_SHIPPING_OPTION}
                      />
                      <FormattedMessage
                        {...messages._PC_PLATE_SPECIFICATIONS_AMBIENT}
                      />
                    </>
                  ) : sessionData[0].shipping === shippingValues.Ice ? (
                    <>
                      <FormattedMessage
                        {...messages.CONF_DUPLEX_SHIPPING_OPTION}
                      />
                      <FormattedMessage
                        {...messages._PC_PLATE_SPECIFICATIONS_ICE}
                      />
                    </>
                  ) : sessionData[0].shipping === shippingValues.DryIce ? (
                    <>
                      <FormattedMessage
                        {...messages.CONF_DUPLEX_SHIPPING_OPTION}
                      />
                      <FormattedMessage
                        {...messages._PC_PLATE_SPECIFICATIONS_DRY_ICE}
                      />
                    </>
                  ) : (
                    ''
                  )
                ) : (
                  ''
                )}
              </span>
            ) : (
              <span>
                <FormattedMessage {...messages.CONF_DUPLEX_SHIPPING_OPTION} />
                <FormattedMessage {...messages.CONF_AMBIENT_ROOM_TEMP} />
              </span>
            )}
          </div>
        </div>
      </Grid>
    </>
  )
}
export default OrderSummary
